import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

const PaginationControls = ({ page, totalPages, onPageChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = isMobile ? 20 : 10;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (page >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <Box className="pd-pagination" sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      alignItems: 'center',
      gap: 1,
      width: '100%'
    }}>
      {/* Previous */}
      <button
        className="btn-negative"
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
        style={{
          width: { xs: '100%', sm: 'auto' }
        }}
      >
        Previous
      </button>

      {/* Page Numbers */}
      <div className="pd-page-numbers" style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '2px'
      }}>
        {renderPageNumbers().map((pageNum, index) => (
          <button
            key={index}
            disabled={pageNum === "..."}
            onClick={() =>
              typeof pageNum === "number" && onPageChange(pageNum)
            }
            className={`pg-type-btn ${pageNum === page ? "active" : ""}`}
            style={{
              minWidth: isMobile ? '32px' : '36px',
              height: isMobile ? '32px' : '36px',
              fontSize: isMobile ? '12px' : '14px'
            }}
          >
            {pageNum}
          </button>
        ))}
      </div>

      {/* Next */}
      <button
        className="btn-negative"
        // disabled={page === totalPages}
        disabled={totalPages === 0 || page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        style={{
          width: { xs: '100%', sm: 'auto' }
        }}
      >
        Next
      </button>
    </Box>
  );
};

export default PaginationControls;